/**
 * UNIT-EDIT-FROM
 * Edit the unit
 */
import RisksValidated from "../../risk/ui/RisksValidated"
import Card from "@/components/card"
import UnitEditInfos from "./UnitEditInfos"
import { t } from "i18next"
import RisksSearch from "../../risk/ui/RisksSearch"
import RisksSort from "../../risk/ui/RisksSort"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import riskStore from "../../risk/model/risk.store"
import { RisksProvider } from "../../risk/context/RisksContext"
import unitStore from "../model/unit.store"
import { faLayerGroup, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "@/components/button"
import { useNavigate } from "react-router-dom"

type Props = { isWizard?: boolean }

export default function UnitEditForm({ isWizard = false }: Props) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const riskFamilies = useAppSelector(riskStore.selectors.listSelectedByUnits)
  const hasRisks = riskFamilies.length > 0
  const activeUnit = useAppSelector(unitStore.selectors.active)
  const risks = useAppSelector(riskStore.selectors.list)
  const unitRisksCount = risks.filter((r) => r.UnitId === activeUnit?.id).length

  useEffect(() => {
    dispatch(
      riskStore.actions.sort({ key: "size", asc: false, keySecondary: "riskMax.valueEffective", ascSecondary: false })
    )
  }, [])
  return (
    <RisksProvider>
      <div>
        <Card title="Informations">
          <UnitEditInfos />
        </Card>

        {/* --- Zone masquée en mode wizard --- */}
        {!isWizard && (
          <>
            <h2 className="mb-4 mt-60">{t("Liste des fiches de risques")}</h2>
            {hasRisks && (
              <p>
                Voici les{" "}
                <b>
                  <FontAwesomeIcon icon={faLayerGroup} className="mr-1 text-gray-400" />
                  {riskFamilies.length}
                </b>{" "}
                «{" "}
                {riskFamilies.length > 0 && riskFamilies[0].Risks.length > 0
                  ? `${Object.keys(riskFamilies[0].Risks[0].attributes || {})[0]}${riskFamilies.length > 1 ? "s" : ""}`
                  : "regroupements"}{" "}
                » contenant{" "}
                <b>
                  <FontAwesomeIcon icon={faTriangleExclamation} className="mr-1 text-gray-400" />
                  {unitRisksCount}
                </b>{" "}
                {unitRisksCount > 1 ? "fiches de risques" : "fiche de risque"} pour cette unité.
              </p>
            )}

            {hasRisks && (
              <div className="flex">
                <RisksSearch />
                <RisksSort hideFirstBorder isUnitView />
              </div>
            )}
            <RisksValidated disableAutoOpen backTo="/risks/units" />
            {!hasRisks && (
              <div className="flex justify-center -mt-8">
                <Button
                  className="primary"
                  isWithBorder
                  onClick={() => navigate("/risks/risks-add", { state: { backTo: "/risks/units" } })}
                  icon={faTriangleExclamation}>
                  {t("risks_add")}
                </Button>
              </div>
            )}
            <div className="h-8" />
          </>
        )}
      </div>
    </RisksProvider>
  )
}
